const extractCognitoAttributesAsObject = (attributesArray) => {
	const output = {};
	attributesArray.forEach(({ Name, Value }) => {
		output[Name] = Value;
	});
	return output;
};

export { extractCognitoAttributesAsObject };
